const Add = (num1, num2) => {
    const num1Digits = (num1.toString().split('.')[1] || '').length;
    const num2Digits = (num2.toString().split('.')[1] || '').length;
    const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
    return (num1 * baseNum + num2 * baseNum) / baseNum;
}

const bubbling = (arr, direction) => {
    for (let i = 0; i < arr.length - 1; i++) {
      for (let j = 0; j < arr.length - i - 1; j++) {
        if (direction === '1') {
          if (arr[j].difficulty > arr[j + 1].difficulty) {
            let swap = arr[j]
            arr[j] = arr[j + 1]
            arr[j + 1] = swap
          }
        } else {
          if (arr[j].difficulty < arr[j + 1].difficulty) {
            let swap = arr[j]
            arr[j] = arr[j + 1]
            arr[j + 1] = swap
          }
        }
      }
    }
    return arr
  }

export { Add, bubbling }